import React from "react";
import { LabelName, InputWrap } from "styles/Form.styled";
import { GridColumn } from "emotion-flex-grid";

const LayoutInput = ({ title, children, display, gap, textarea, dropDownStyle, fontsize }) => {
  return (
    <InputWrap gap={gap} textarea={textarea} dropDownStyle={dropDownStyle} fontsize={fontsize}>
      <GridColumn width={[12, "180px", "216px"]}>
        <LabelName>{title}</LabelName>
      </GridColumn>
      <GridColumn display={display} flex="1">
        {children}
      </GridColumn>
    </InputWrap>
  );
};

export default LayoutInput;
